import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 52 52"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.875"
    }, [
      _createElementVNode("path", { d: "M51 21c-.093-3.278-.405-5.367-1.456-7.15-1.494-2.537-4.186-3.948-9.57-6.771l-5.003-2.624C30.578 2.152 28.382 1 26.02 1s-4.56 1.152-8.952 3.455l-5.004 2.624c-5.383 2.823-8.075 4.234-9.57 6.77C1 16.386 1 19.542 1 25.854v.292c0 6.312 0 9.469 1.495 12.005 1.494 2.536 4.186 3.947 9.57 6.77l5.003 2.624C21.461 49.848 23.657 51 26.02 51s4.558-1.152 8.95-3.455l5.005-2.624c5.383-2.823 8.075-4.234 9.57-6.77C50.594 36.367 50.906 34.278 51 31" }),
      _createElementVNode("path", { d: "m48.537 14.75-10.008 5M26.02 26 3.503 14.75M26.02 26v23.75m0-23.75 11.258-5.625 1.251-.625m0 0v8.75m0-8.75L14.761 7.25" })
    ], -1)
  ]))]))
}
export default { render: render }